

























































import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import { DxButton, DxLookup } from 'devextreme-vue';
import notify from 'devextreme/ui/notify';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import EmailTemplateEditor from '@/components/fee-sheets/email-template-editor.vue'
import { TextTemplateService } from '@/service/TextTemplateService'
import { UserService } from '@/service/UserService'
import { TextTemplateTypeEnum } from '@/models/TextTemplateTypeEnum';
import { TextTemplateDto } from '@/models/TextTemplateDto';
import { UserSettingName } from '@/models/UserSetting';
import CommentsGrid from '../../components/activity-planner/comments-grid.vue';

@Component({
  components: {
    PageTitle,
    DxLookup,
    DxButton,
    EmailTemplateEditor,
    CommentsGrid
  }
})
export default class Comments extends Vue {
  private displayTemplateEditor: boolean = false;
  private textTemplateService: TextTemplateService;
  private userService: UserService;
  private respondToAgentValue: Guid = "";
  private forwardToClientValue: Guid = "";
  private doneInitialLoad: boolean = false;

  constructor() {
    super();
    this.textTemplateService = new TextTemplateService();
    this.userService = new UserService();
  }

  private get respondToAgentDataSource() {
    return new DataSource({
      store: this.respondToAgentStore,
    });
  }

  private get forwardToClientDataSource() {
    return new DataSource({
      store: this.forwardToClientStore,
    });
  }

  private respondToAgentStore: CustomStore = new CustomStore({
          loadMode: 'raw',
          key: 'TextTemplateId',
          load: (options): Promise<TextTemplateDto[]> => {
          return this.textTemplateService.getTextTemplate(TextTemplateTypeEnum.RespondToAgent);
        }
  });

  private forwardToClientStore: CustomStore = new CustomStore({
          loadMode: 'raw',
          key: 'TextTemplateId',
          load: (options): Promise<TextTemplateDto[]> => {
          return this.textTemplateService.getTextTemplate(TextTemplateTypeEnum.ForwardToClient);
        }
  });

  mounted() {
    this.userService.getCommentSettings().then(x=>{
      let respondToAgent = x.find(x=>x.Name == UserSettingName.RespondToAgent)
      this.respondToAgentValue = respondToAgent != null ? respondToAgent.Value : "";

      let forwardToClient = x.find(x=>x.Name == UserSettingName.ForwardToClient);
      this.forwardToClientValue = forwardToClient != null ? forwardToClient.Value: "";
      setTimeout(()=>{ this.doneInitialLoad = true }, 1000)
    })

    
  }

  private showTemplatePopup(show: boolean = true) {
    this.displayTemplateEditor = show;
  }

  private hideTemplatePopup() {
    this.showTemplatePopup(false);
    this.respondToAgentDataSource.reload();
    this.forwardToClientDataSource.reload();
  }

  private respondToAgentChanged(e:any) {
    this.updateCommentSetting(UserSettingName.RespondToAgent, e)
  }

  private forwardToClientChanged(e:any) {
    this.updateCommentSetting(UserSettingName.ForwardToClient, e)
  }

  private updateCommentSetting(name: string, e: any) {
    if(this.doneInitialLoad) {
      let selected: string | null = null;
      if(e && e.selectedItem) {
        selected =  (e.selectedItem as TextTemplateDto).TextTemplateId;
      }
      this.userService.updateCommentSettings(name, selected).then(x=> {
        notify('Updated comment template','success', 1000);
      })
    }
  }

}
